<div *ngIf="totalItems > 0" class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
  <!-- Page Size Dropdown and Info (Stacked on smaller screens) -->
  <div class="mb-3 mb-md-0">
    <label for="pageSize" class="me-2">Page Size:</label>
    <select id="pageSize" class="form-select d-inline w-auto changePageSize" (change)="changePageSize($event)">
      <option *ngFor="let size of pageSizes" [value]="size" [selected]="size === pageSize">{{ size }}</option>
    </select>
    <span class="ms-3"> {{ totalPages == 0 ? 0 : currentPage }} — {{ totalPages }} of {{totalItems}} </span>
  </div>

  <!-- Pagination Controls -->
  <nav>
    <ul class="pagination">
  <li class="page-item" [class.disabled]="currentPage === 1">
    <a class="page-link" (click)="previousPage()">&laquo;</a>
  </li>

  <li *ngFor="let page of getPages()" class="page-item" [class.active]="page === currentPage">
    <a class="page-link" (click)="selectPage(page)">{{ page }}</a>
  </li>

  <ng-container *ngIf="totalPages > 5 && currentPage < (totalPages - 2)">
    <li class="page-item disabled">
      <span class="page-link">...</span>
    </li>
    <li class="page-item">
      <a class="page-link" (click)="selectPage(totalPages)">{{ totalPages }}</a>
    </li>
  </ng-container>

  <li class="page-item" [class.disabled]="currentPage === totalPages">
    <a class="page-link" (click)="nextPage()">&raquo;</a>
  </li>
</ul>
  </nav>
</div>
